import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import Api from "../../../../../Services/Api";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import {removeNullFields} from "../../../../common/mapper";

class InventorySearchDataSPBM extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableColumns: [
                {
                    name: "",
                    label: "No",
                    options: {
                        customBodyRender: (_, tableMeta) => {
                            const {page, rowsPerPage} = tableMeta.tableState;
                            const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                            return <>{rowNumber}</>;
                        },
                        sort: false,
                    },
                },
                {
                    name: "spbmNo",
                    label: "No. SPBM",
                    options: {
                        customBodyRender: (val) => <p>{val}</p>,
                        sort: false,
                    },
                },
                {
                    name: "spbmDate",
                    label: "Tanggal",
                    options: {
                        customBodyRender: (val) => <p>{val}</p>,
                        sort: false,
                    },
                },
                {
                    name: "checked",
                    label: "Action",
                    options: {
                        customBodyRender: (val, tableMeta) => {
                            return (
                                <FlexView vAlignContent="center" style={{gap: 10}}>
                                    <SimpleCheckBox
                                        id="checkbox_action"
                                        checked={val}
                                        onChange={(e) => this.handleSelectData(tableMeta.rowIndex, e)}
                                    />
                                </FlexView>
                            );
                        },
                        sort: false,
                    },
                },
            ],
            loading: false,
            search: {
              spbmNo: null,
            },
            dataTable: [],
            pagination: {
                count: 10,
                limit: 5,
                page: 1,
                orderBy: "id",
                sort: "ASC",
            }
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    handleValueChangeSearch = (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            search: {
                ...prevState.search,
                [name]: value,
            },
        }))
    }

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        await this.fetchData({
            ...removeNullFields((this.state.search)),
            dealerCode: this.props.selectedCabang?.value,
            limit: this.state.pagination.limit,
            page: 1,
        });
        this.handleTriggerLoading();
    }

    handleSelectData = (index, e) => {
        const isChecked = e.target.checked;
        this.setState((prevState) => ({
            ...prevState,
            dataTable: prevState.dataTable.map((data, i) => ({
                ...data,
                checked: i === index ? isChecked : false,
            }))
        }));
    }

    handleSubmit = () => {
        const checkedData = this.state.dataTable.find(data => data.checked);
        this.props.onSubmit(checkedData);
    }

    handleChangePage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        let page = tableState.page + 1;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: page,
                limit: limit,
            },
        }));
        await this.fetchData({dealerCode: this.props.selectedCabang?.value, page: page, limit: limit});
        this.handleTriggerLoading();
    }

    handleChangeRowsPerPage = async (tableState) => {
        this.handleTriggerLoading();
        let limit = tableState.rowsPerPage;
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                count: 1,
                page: 1,
                limit: limit,
            }
        }));
        await this.fetchData({dealerCode: this.props.selectedCabang?.value, page: 1, limit: limit});
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchData = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_TRANSACTION").getAllReceivingUnitNOSByParam(
                body && Object.keys(body).length > 0 ?
                    body :
                    {dealerCode: this.props.selectedCabang?.value, page: 1, limit: 5}
            );

            if (res.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataTable: res.data.data,
                    pagination: {
                        ...prevValue.pagination,
                        count: res.data.totalData ? res.data.totalData : 5,
                    }
                }));
            }
        } catch (e) {
            console.log("errors: ", e);
        }
    }

    render() {
        console.log("props: ", this.props);
        console.log("state: ", this.state);
        return (
            <>
                <SimpleModal
                    title="Search Data SPBM"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <FlexView vAlignContent={"center"} style={{marginBottom: "20px"}}>
                                <div className="margin-right-20px">
                                    <div className="txt-site txt-11 txt-main txt-bold">
                                        <h4>
                                            No. SPBM:
                                        </h4>
                                    </div>
                                </div>
                                <SimpleInput
                                    type="text"
                                    name="spbmNo"
                                    containerclassname="margin-bottom-none"
                                    value={this.state.search.spbmNo}
                                    onChange={(e) => this.handleValueChangeSearch(e.target.name, e.target.value)}
                                />
                                <SimpleButton
                                    text="Cari"
                                    className="margin-top-5px"
                                    onClick={this.handleSubmitSearch}
                                />
                            </FlexView>
                            <SimpleDataTable
                                data={this.state.dataTable}
                                columns={this.state.tableColumns}
                                toCount={this.state.pagination.count}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page-1}
                                options={defaultTableChange(
                                    (tableState) => this.handleChangePage(tableState),
                                    (tableState) => this.handleChangeRowsPerPage(tableState),
                                )}
                            />
                            <div style={{textAlign: "right", marginTop: "10px"}}>
                                <SimpleButton
                                    text="Pilih"
                                    type="button"
                                    onClick={() => this.handleSubmit()}
                                />
                            </div>
                        </ModalContainer>
                    }
                />

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        )
    }
}

export default InventorySearchDataSPBM;